import React, { useEffect } from "react"
import { FormProvider, useForm } from "react-hook-form"

import classNames from "classnames"

import { noop } from "shared/lib/noop"
import { WithChildren } from "shared/types/WithChildren"
import { WithClassName } from "shared/types/WithClassName"

import { PortalNewsFilterFormData } from "entities/portal-news/types/PortalNewsFilter"

import { PortalNewsSearchInput } from "./ui/PortalNewsSearchInput"

export interface PortalNewsFilterModel {
  defaultValues?: PortalNewsFilterFormData
  onChange?: (filterState: PortalNewsFilterFormData) => void
}

export interface PortalNewsFilterProps
  extends PortalNewsFilterModel,
    WithClassName,
    WithChildren {}

const PortalNewsFilterRoot = React.memo(
  ({ defaultValues, onChange, className, children }: PortalNewsFilterProps) => {
    const form = useForm<PortalNewsFilterFormData>({ defaultValues })

    useEffect(() => {
      const unsubscribe = form.subscribe({
        formState: { values: true },
        callback({ values }) {
          onChange?.(values)
        }
      })
      return () => unsubscribe()
    }, [form])

    return (
      <FormProvider {...form}>
        <form
          className={classNames("portal-news-filter", className)}
          onSubmit={form.handleSubmit(noop)}
        >
          {children}
        </form>
      </FormProvider>
    )
  }
)

export const PortalNewsFilter = {
  Root: PortalNewsFilterRoot,
  Search: PortalNewsSearchInput
}
